import React from "react";
import "./book-mark.scss";
import "./hamburger-menu.scss";
interface HamburgerMenuPropsType {
    isToggleMenuVisible: boolean;
    onClickHamburgerMenu: any;
}
export const HamburgerMenu = (props: HamburgerMenuPropsType) => {
    return (
        <div className={props.isToggleMenuVisible ? "header__hamburger-menu hamburger-menu--clicked" : "header__hamburger-menu"} onClick={props.onClickHamburgerMenu}>
            <div className="hamburger-lines">
                <span className="line line1"></span>
                <span className="line line2"></span>
                <span className="line line3"></span>
            </div>
        </div>
    )
}